import { ccwpApi } from "@/services";
import { CREDITORLIST, CREDITOR_SEARCH_LIST } from "../constant/apiPath";
import { maxPageSize } from "@/Constant";

// Define a service using a base URL and expected endpoints
export const CreditorListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditorList: builder.query<any, void>({
      query: (caseId) => {
        return {
          url: CREDITORLIST + caseId + `&PageNumber=1&PageSize=${maxPageSize}`,
        };
      },
      transformResponse: (response: { results: any[] }) => response.results,
      providesTags: ["CreditorList"],
    }),
    getProvinces: builder.query<any, void>({
      query: (countryId) => {
        return {
          url: `Common/ListProvinceStatesByCountry?CountryId=${countryId}`,
        };
      },
      keepUnusedDataFor: 60 * 60 * 8, // 8 hrs in seconds
    }),
    // searchCaseListData: builder.query<
    //   any,
    //   {
    //     Type?: string;
    //     caseID?: string;
    //     OrderBy?: string;
    //     Keyword?: string;
    //     PageNo?: number;
    //     PageSize?: number;
    //   }
    // >({
    //   query: (searchParams) => {
    //     const params = {
    //       ...searchParams,
    //     };
    //     return {
    //       url: CREDITORLIST,
    //       params: params,
    //     };
    //   },
    // }),
    searchCreditorListData: builder.query<
      any,
      { CaseId?: string; SearchText?: string, PageNumber?: number; PageSize?: number }
    >({
      query: (args) => {
        let params:any = {
          ...args,
        };
        if (!(params?.PageSize && params?.PageNumber)) {
          params.PageSize = maxPageSize;
          params.PageNumber = 1;
        }
        return {
          url: CREDITOR_SEARCH_LIST,
          params: params,
        };
      },
    }),
    searchCreditorTabListData: builder.query<any, any>({
      query: (args) => {
        return {
          url: CREDITOR_SEARCH_LIST,
          params: { ...args },
        };
      },
    }),
    getCreditorListByCreditorIdAndCaseId: builder.query<
      any,
      { caseId?: string; creditorId?: string }
    >({
      query: ({ caseId, creditorId }) => {
        return {
          url: `${CREDITORLIST + caseId}&CreditorId=${creditorId}&PageNumber=1&PageSize=100`,
        };
      },
      transformResponse: (response: { results: any[] }) => response.results,
      providesTags: ["CreditorList"],
    }),
    disableCrediotrAction: builder.mutation({
      query: (creditorsId) => ({
        url: `Creditor/DisableCreditor?CreditorID=${creditorsId}`,
        method: "PATCH",
      }),
    }),
    createCreditor: builder.mutation({
      query: (data) => ({
        url: "Creditor/AddNewCreditor",
        method: "POST",
        body: data,
      }),
    }),
    updateCreditor: builder.mutation({
      query: (data) => ({
        url: "Creditor/UpdateCreditorDetails",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCreditorListQuery,
  useSearchCreditorListDataQuery,
  useLazySearchCreditorListDataQuery,
  useSearchCreditorTabListDataQuery,
  useLazySearchCreditorTabListDataQuery,
  useGetProvincesQuery,
  useLazyGetProvincesQuery,
  useGetCreditorListByCreditorIdAndCaseIdQuery,
  useLazyGetCreditorListByCreditorIdAndCaseIdQuery,
  useDisableCrediotrActionMutation,
  useCreateCreditorMutation,
  useUpdateCreditorMutation,
} = CreditorListApi;

export const basicSearchCreditorListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreviewBasicSearchCreditorListApiData: builder.query<any, any>({
      query: (arg) => {
        let newUrl = CREDITORLIST + arg.caseId;
        if (arg.creditorName) {
          newUrl += "&CreditorName=" + arg.creditorName;
        }
        if (arg.creditorId) {
          newUrl += "&CreditorReference=" + arg.creditorId;
        }
        if (arg.claimId) {
          newUrl += "&ClaimReference=" + arg.claimId;
        }
        if (arg.debtorName) {
          newUrl += "&DebtorName=" + arg.debtorName;
        }
        if (arg.country) {
          newUrl += "&CountryId=" + arg.country;
        }
        if (arg.province) {
          newUrl += "&ProvinceStateId=" + arg.province;
        }
        if (arg.postalCode) {
          newUrl += "&PostalCode=" + arg.postalCode;
        }
        if (arg.phoneNumber) {
          newUrl += "&PhoneNumber=" + arg.phoneNumber;
        }
        if (arg.updateDate) {
          newUrl += "&ClaimUpdateDate=" + arg.updateDate;
        }
        if (arg?.PageNumber) {
          newUrl += "&PageNumber=" + arg.PageNumber;
        }
        if (arg?.PageSize) {
          newUrl += "&PageSize=" + arg.PageSize;
        }
        if (arg?.SortColumn) {
          newUrl += "&SortColumn=" + arg.SortColumn;
        }
        if (arg?.SortOrder) {
          newUrl += "&SortOrder=" + arg.SortOrder;
        }
        return newUrl;
      },
    }),
    getBasicSearchCreditorTabListApiData: builder.query<any, any>({
      query: (arg) => {
        let newUrl = CREDITORLIST + arg.caseId;
        if (arg.creditorName) {
          newUrl += "&CreditorName=" + arg.creditorName;
        }
        if (arg.creditorId) {
          newUrl += "&CreditorReference=" + arg.creditorId;
        }
        if (arg.claimId) {
          newUrl += "&ClaimReference=" + arg.claimId;
        }
        if (arg.debtorName) {
          newUrl += "&DebtorName=" + arg.debtorName;
        }
        if (arg.country) {
          newUrl += "&CountryId=" + arg.country;
        }
        if (arg.province) {
          newUrl += "&ProvinceStateId=" + arg.province;
        }
        if (arg.postalCode) {
          newUrl += "&PostalCode=" + arg.postalCode;
        }
        if (arg.phoneNumber) {
          newUrl += "&PhoneNumber=" + arg.phoneNumber;
        }
        if (arg.updateDate) {
          newUrl += "&ClaimUpdateDate=" + arg.updateDate;
        }
        if (arg?.PageNumber) {
          newUrl += "&PageNumber=" + arg.PageNumber;
        }
        if (arg?.PageSize) {
          newUrl += "&PageSize=" + arg.PageSize;
        }
        if (arg?.SortColumn) {
          newUrl += "&SortColumn=" + arg.SortColumn;
        }
        if (arg?.SortOrder) {
          newUrl += "&SortOrder=" + arg.SortOrder;
        }
        return newUrl;
      },
    }),
  }),
});
export const {
  useGetPreviewBasicSearchCreditorListApiDataQuery,
  useLazyGetPreviewBasicSearchCreditorListApiDataQuery,
  useGetBasicSearchCreditorTabListApiDataQuery,
} = basicSearchCreditorListApi;
